import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=11819756&scoped=true"
import script from "./complaints.vue?vue&type=script&lang=ts"
export * from "./complaints.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11819756",
  null
  
)

export default component.exports